module.exports = __webpack_public_path__ + "static/media/squared.61a6800d.jpg";